<template>
  <section class="section cms-text-image-alt">
    <b-container>
      <div class="cms-text-image-alt__vp">
        <b-row :style="`flex-direction: ${reverse ? 'row-reverse' : 'row'};`">
          <b-col v-if="resolved_image" lg="4" xl="6">
            <div class="cms-text-image-alt__right">
              <img :src="resolved_image.url" :alt="resolved_image.alt" />
            </div>
          </b-col>
          <b-col
            :lg="resolved_image ? 8 : 12"
            :xl="resolved_image ? 6 : 12"
          >
            <div class="cms-text-image-alt__left">
              <div
                v-for="(paragraph, paragraph_index) in resolved_paragraphs"
                :key="`cms-paragraph-${paragraph_index}`"
              >
                <div class="cms-text-image-alt__icon">
                  <vb-icon :name="'symbol_lb'" color="--secondary" />
                </div>
                <div>
                  <div
                    v-if="paragraph.title"
                    class="h3 cms-text-image-alt__title"
                    v-html="paragraph.title"
                  ></div>
                  <div class="cms-text-image-alt__text">
                    <span v-if="paragraph.text" v-html="paragraph.text"></span>
                    <content-link
                      v-if="paragraph.resolved_link"
                      :link="paragraph.resolved_link"
                    >
                      <strong>{{
                        paragraph.resolved_link.label || 'Scopri di più'
                      }}</strong>
                    </content-link>
                  </div>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </section>
</template>

<script>
  /**
   * CMS `text-image-alt` block: image alongside a list of paragraphs.
   * Schema (props): `{ reverse, image, paragraphs: [{ title, text, link }] }`.
   * Mirrors the original library/blocks/value-proposition.vue component: the
   * icon does not come from the payload but is fixed (`symbol_lb`, color
   * secondary), like vp_icon in the static sections.
   */
  import { resolve_link, resolve_media } from './content-utilities';
  import ContentLink from './content-link.vue';

  export default {
    name: 'text-image-alt',

    components: { 'content-link': ContentLink },

    props: {
      reverse: {
        type: Boolean,
        default: false,
      },
      image: {
        type: [Object, String],
        default: null,
      },
      paragraphs: {
        type: Array,
        default: () => [],
      },
    },

    computed: {
      resolved_image() {
        return resolve_media(this.image);
      },
      resolved_paragraphs() {
        return (this.paragraphs || []).map((paragraph) => ({
          ...paragraph,
          resolved_link: resolve_link(paragraph.link),
        }));
      },
    },
  };
</script>

<style lang="scss" scoped>
  .cms-text-image-alt {
    &__vp {
      background: $white;
      border-radius: $border-radius-lg * 2;
      overflow: hidden;
    }

    &__left {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 100%;

      & > div {
        display: flex;
        padding: $grid-gutter-width * 2 $grid-gutter-width * 2
          $grid-gutter-width * 2 $grid-gutter-width;

        &:not(:last-child) {
          margin-bottom: $grid-gutter-width * 2;
        }

        @include media-breakpoint-up(lg) {
          padding: 0 $grid-gutter-width * 2 0 0;
        }
      }
    }

    &__right {
      position: relative;
      min-height: 240px;

      img {
        position: absolute;
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: top center;
      }

      @include media-breakpoint-up(md) {
        min-height: 500px;
      }
    }

    &__icon {
      margin: 0 1rem;
    }

    &__title {
      @include font-primary-semibold;
      margin-bottom: 1rem;
    }

    &__text {
      a {
        color: $vb-body-color;

        &:hover {
          color: $link-color;
          text-decoration: underline;
        }
      }
    }
  }
</style>
